module.exports = __webpack_public_path__ + "static/media/ProjectThumb.f24e5613.png";